import * as RadixCheckbox from '@radix-ui/react-checkbox'
import { styled } from '../../../config/stitches'

export const CheckBoxRoot = styled(RadixCheckbox.Root, {
  all: 'unset',
  backgroundColor: 'white',
  width: '20px',
  height: '20px',
  borderRadius: '6px',
  borderWidth: '1px',
  borderColor: `$gray0300`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  borderStyle: 'solid',
  cursor: 'pointer',
  boxSizing: 'inherit',
  variants: {
    colorScheme: {
      indigo: {
        '&[data-state="checked"]': {
          background: '$indigo0600',
          borderColor: '$indigo0600'
        }
      },
      dark: {
        borderColor: '$white',
        backgroundColor: 'transparent',
        '&[data-state="checked"]': {
          backgroundColor: '$white',
          borderColor: '$white',
          color: '$black'
        }
      },
      transparent: {
        backgroundColor: 'transparent',
        borderColor: '$white'
      }
    }
  }
})
